import { render, staticRenderFns } from "./Estadisticas.vue?vue&type=template&id=79df3e42&scoped=true&"
import script from "./Estadisticas.vue?vue&type=script&lang=js&"
export * from "./Estadisticas.vue?vue&type=script&lang=js&"
import style0 from "./Estadisticas.scss?vue&type=style&index=0&id=79df3e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79df3e42",
  null
  
)

export default component.exports